import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';

export const locationsApiUrl = 'Locations';

function GetLocationsRequest(limit = 10, search = null) {
  return nzApiAxios.get(locationsApiUrl, { params: { search, limit } }).then((response) => response.data);
}

const API = {
  getLocations: GetLocationsRequest
};

export default API;
